import TokenLogo from '~/components/TokenLogo'
import { getNetworkLogo } from '~/utils/chain'
import {
  StyledTokenWrap,
  StyledTokenWrapLeft,
  StyledTokenSymbol,
  StyledTriangle,
} from './styled'
import IconLock from '~/assets/images/lock.svg'

interface TokenProps {
  token: BaseTokenlonToken & {
    chainId?: number
  }
  testid?: string
  onClick?: () => void
  needApprove?: boolean
}

export const Token: React.FC<TokenProps> = ({
  token,
  testid,
  onClick,
  needApprove,
}) => {
  const { logo, symbol, chainId } = token || {}
  const networkLogo = getNetworkLogo(chainId)
  const withSelection = typeof onClick === 'function'

  if (!logo && !symbol) return <StyledTokenWrap withSelection={withSelection} />

  return (
    <StyledTokenWrap
      withSelection={withSelection}
      onClick={onClick}
      data-testid={testid}
    >
      <StyledTokenWrapLeft>
        <TokenLogo
          large
          space={0}
          logo={logo}
          symbol={symbol}
          networkLogo={networkLogo}
          showNetworkBadge={true}
        />
        <StyledTokenSymbol>{symbol}</StyledTokenSymbol>
        {needApprove && (
          <img src={IconLock} style={{ marginLeft: 4 }} alt="lock" />
        )}
      </StyledTokenWrapLeft>
      {withSelection && <StyledTriangle />}
    </StyledTokenWrap>
  )
}

export default Token
